module.exports = __webpack_public_path__ + "static/media/studio1.cdd37893.png";